import { useState } from "react";
import Modal from 'react-modal';
import useKeypress from "../../ownHooks/pressEsc";


export default function ZeileLöschenLD ({
    row: { original },
    deleteSpecificRow

}) {
    const auth = sessionStorage.getItem('token');

    const [showModal, setShowModal] = useState(false);

    const deleteRow = event => {
        event.preventDefault();
        console.log("lösche ", original.id);
        console.log(original);
        deleteSpecificRow(original.id);
        closeModal();
    }

    const openModal = event => {
        event.preventDefault();
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    
    useKeypress('Escape', () => {
            closeModal();
    });

    if (auth.includes('level1')) {
            return <div>
                <button onClick={openModal}>&#129529;</button>
                {/* <button onClick={openModal}>&#xe020;</button> */}

                {showModal && <Modal className="modal" isOpen={showModal}>
                    <button className="bttn-close-modal" onClick={closeModal}>&#10007; </button>

                    <p>Soll dieser Datensatz wirklich gelöscht werden?</p>
                    <p className="text-cursive">{original.jahr}-{original.linie}-{original.vertrag}-{original.verband}-{original.produkt}</p>
                    <button onClick={deleteRow}>Ja</button>
                    <button onClick={closeModal}>Nein</button>
                </Modal>}
             </div>
    }
   
}